import modules_statements from './statements/index.js'
import modules_regulars from './regulars/index.js'
import modules_payments from './payments/index.js'
import modules_paymentItems from './paymentItems/index.js'
import modules_osv from './osv/index.js'
import modules_invoices from './invoices/index.js'
import modules_certificates from './certificates/index.js'
import _actions_filter_edit from './_actions/filter/edit.js'
import _actions_filter_change from './_actions/filter/change.js'
import _actions_change_type from './_actions/change/type.js'
import _actions_change_setting from './_actions/change/setting.js'
import _actions_change_position from './_actions/change/position.js'
import _actions_change_opened from './_actions/change/opened.js'
import _actions_change_header from './_actions/change/header.js'
import _actions_change_data from './_actions/change/data.js'
import _actions_save from './_actions/save.js'
import _actions_reset from './_actions/reset.js'
import _actions_open from './_actions/open.js'
import _actions_get from './_actions/get.js'
import _actions_cancel from './_actions/cancel.js'
import _actions_add_filter from './_actions/add_filter.js'

export default {
    namespaced: true,
    actions:{
        add_filter: _actions_add_filter,
        cancel: _actions_cancel,
        get: _actions_get,
        open: _actions_open,
        reset: _actions_reset,
        save: _actions_save,
        change_data: _actions_change_data,
        change_header: _actions_change_header,
        change_opened: _actions_change_opened,
        change_position: _actions_change_position,
        change_setting: _actions_change_setting,
        change_type: _actions_change_type,
        filter_change: _actions_filter_change,
        filter_edit: _actions_filter_edit,
    },
    modules:{
        certificates: modules_certificates,
        invoices: modules_invoices,
        osv: modules_osv,
        paymentItems: modules_paymentItems,
        payments: modules_payments,
        regulars: modules_regulars,
        statements: modules_statements,
    },
}